import React from 'react';
import {Buscador} from './Buscador';
import {Resultados} from "./Resultados";
import {SearchStore, SearchTermsStore, StateQueryStore} from "ocs-search-commons";
import {AppStore} from './stores/AppStore';
import {notaSearchItemsBuilder} from './stores/SearchItemsDefinition';


const stateQueryStore = new StateQueryStore();
const searchTermsStore = new SearchTermsStore(notaSearchItemsBuilder);
const searchStore = new SearchStore(searchTermsStore, stateQueryStore);
const appStore = new AppStore(searchStore);

export const storesContext = React.createContext({
  searchStore: searchStore,
  searchTermsStore: searchTermsStore,
  stateQueryStore: stateQueryStore,
  appStore: appStore
});

export const useStores = () => React.useContext(storesContext);

const App = () => {
  return (
    <div className="container flex-grow mx-auto d-flex">
      <Buscador />
      <Resultados />
    </div>
  );
};

export default App;
 
